//updates worker information.
import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import BackButton from '../components/BackButton'
import { useSelector, useDispatch } from 'react-redux'
import { updateWorker, reset, terminateWorker } from '../features/workers/workerSlice';
import { toast } from 'react-toastify'
import { FaEdit } from 'react-icons/fa';


const UpdateWorkerInfo = () => {
  //props passed from previous route on click. 
  const location = useLocation();
  const dispatch = useDispatch();
  const props = location.state;
  

  // const user = useSelector()


  //redux states
  const {message, isSuccess} = useSelector(state => state.workers)
    //whenever the message changes, show a toast message
    useEffect(() => {
  

      if(message) {
        if(isSuccess === false){
          toast.error(message);
        } else {
          toast.success(message);
        }
        dispatch(reset())
      }
        
    }, [message, isSuccess, dispatch]);


  const [editMode, setEditMode] = useState({
    rate: false,
    role: false,
    name: false,
    lastName: false,
    // phone is not editable
  });

  const [formData, setFormData] = useState({
    workerID: props.currentWorkerData.id,
    newRole: props.currentWorkerData.role || '',
    newRate: props.currentWorkerData.rate || '',
    newName: props.currentWorkerData.name || '',
    newLastName: props.currentWorkerData.lastName || '',
  });



  const handleInputChange = (event) => {
    const { name, value } = event.target;

    let formattedValue = value;
    if (name === 'newPhone') {
      // Remove all non-digit characters
      formattedValue = formattedValue.replace(/\D/g, '');
  
      // Add dashes in the pattern ###-###-####
      if (formattedValue.length > 3) {
        formattedValue = formattedValue.slice(0, 3) + '-' + formattedValue.slice(3);
      }
      if (formattedValue.length > 7) {
        formattedValue = formattedValue.slice(0, 7) + '-' + formattedValue.slice(7, 11);
      }
    }

    setFormData((prevData) => ({
      ...prevData,
      [name]: formattedValue
    }));
  };

  const formatPhoneNumber = (phoneNumber) => {
    if (!phoneNumber) return '';
    const cleaned = ('' + phoneNumber).replace(/\D/g, '');
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return `${match[1]}-${match[2]}-${match[3]}`;
    }
    return phoneNumber;
  };


  const handleSubmit = (e) => {
    
    e.preventDefault(); 
    //dispath the updateWorker function with formData as parameter. 
     dispatch( updateWorker( formData) )

  };

  //Pass the worker id and a user token to the terminateWorker function.

  // Modal state
  const [showModal, setShowModal] = useState(false);

  const handleRemoveWorker = (e) => {
    e.preventDefault();
    setShowModal(true);
  };

  const handleConfirmDelete = () => {
    setShowModal(false);
    dispatch(terminateWorker(props.currentWorkerData.id));
  };

  const handleCancelDelete = () => {
    setShowModal(false);
  };

  const handleEditClick = (field) => {
    setEditMode((prev) => ({ ...prev, [field]: true }));
  };

  const handleInputBlur = (field) => {
    setEditMode((prev) => ({ ...prev, [field]: false }));
  };

  const handleInputKeyDown = (e, field) => {
    if (e.key === 'Enter') {
      setEditMode((prev) => ({ ...prev, [field]: false }));
    }
  };

  return (
    <>
      <div className="min-h-screen bg-sage flex items-center justify-center py-6 px-2 sm:px-0">
        <div className="w-full max-w-lg bg-white rounded-2xl shadow-xl p-4 sm:p-8 flex flex-col items-center">
          <form onSubmit={handleSubmit} className="w-full flex flex-col gap-6">
            <div className="flex flex-col items-center w-full p-4 rounded-xl bg-slate-100 shadow-sm mb-2 sm:mb-4">
              <img
                src={props.currentWorkerData.profilePicture}
                alt="Worker"
                className="w-24 h-24 rounded-full object-cover border-4 border-robin shadow mb-2"
              />
              <div className="flex flex-col sm:flex-row items-center w-full justify-center gap-1 sm:gap-3 mt-2">
                <span className="capitalize font-semibold text-charcoal">Phone:</span>
                <span className="text-gray-600 tracking-wide">{formatPhoneNumber(props.currentWorkerData.phone)}</span>
              </div>
              {/* Editable fields */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 w-full mt-4">
                {/* Name */}
                <div className="flex items-center justify-between bg-white rounded-lg px-2 py-1 border border-gray-200">
                  <span className="font-semibold text-charcoal">Name:</span>
                  {editMode.name ? (
                    <input
                      name="newName"
                      type="text"
                      value={formData.newName}
                      onChange={handleInputChange}
                      onBlur={() => handleInputBlur('name')}
                      onKeyDown={(e) => handleInputKeyDown(e, 'name')}
                      className="ml-2 p-1 border border-gray-300 rounded-md w-28 sm:w-32 focus:outline-none focus:ring-2 focus:ring-robin"
                      autoFocus
                    />
                  ) : (
                    <span className="flex items-center text-gray-700 ml-2">
                      {formData.newName}
                      <button type="button" className="ml-2 text-robin hover:text-blue-700" onClick={() => handleEditClick('name')}>
                        <FaEdit />
                      </button>
                    </span>
                  )}
                </div>
                {/* Last Name */}
                <div className="flex items-center justify-between bg-white rounded-lg px-2 py-1 border border-gray-200">
                  <span className="capitalize font-semibold text-charcoal">Last Name:</span>
                  {editMode.lastName ? (
                    <input
                      name="newLastName"
                      type="text"
                      value={formData.newLastName}
                      onChange={handleInputChange}
                      onBlur={() => handleInputBlur('lastName')}
                      onKeyDown={(e) => handleInputKeyDown(e, 'lastName')}
                      className="ml-2 p-1 border border-gray-300 rounded-md w-28 sm:w-32 focus:outline-none focus:ring-2 focus:ring-robin"
                      autoFocus
                    />
                  ) : (
                    <span className="flex items-center text-gray-700 ml-2">
                      {formData.newLastName}
                      <button type="button" className="ml-2 text-robin hover:text-blue-700" onClick={() => handleEditClick('lastName')}>
                        <FaEdit />
                      </button>
                    </span>
                  )}
                </div>
                {/* Rate */}
                <div className="flex items-center justify-between bg-white rounded-lg px-2 py-1 border border-gray-200">
                  <span className="capitalize font-semibold text-charcoal">Rate:</span>
                  {editMode.rate ? (
                    <input
                      name="newRate"
                      type="number"
                      step="0.01"
                      value={formData.newRate}
                      onChange={handleInputChange}
                      onBlur={() => handleInputBlur('rate')}
                      onKeyDown={(e) => handleInputKeyDown(e, 'rate')}
                      className="ml-2 p-1 border border-gray-300 rounded-md w-20 sm:w-24 focus:outline-none focus:ring-2 focus:ring-robin"
                      min={7.25}
                      autoFocus
                    />
                  ) : (
                    <span className="flex items-center text-gray-700 ml-2">
                      {formData.newRate}
                      <button type="button" className="ml-2 text-robin hover:text-blue-700" onClick={() => handleEditClick('rate')}>
                        <FaEdit />
                      </button>
                    </span>
                  )}
                </div>
                {/* Role */}
                <div className="flex items-center justify-between bg-white rounded-lg px-2 py-1 border border-gray-200">
                  <span className="capitalize font-semibold text-charcoal">Role:</span>
                  {editMode.role ? (
                    <input
                      name="newRole"
                      type="text"
                      value={formData.newRole}
                      onChange={handleInputChange}
                      onBlur={() => handleInputBlur('role')}
                      onKeyDown={(e) => handleInputKeyDown(e, 'role')}
                      className="ml-2 p-1 border border-gray-300 rounded-md w-20 sm:w-24 focus:outline-none focus:ring-2 focus:ring-robin"
                      autoFocus
                    />
                  ) : (
                    <span className="flex items-center text-gray-700 ml-2">
                      {formData.newRole}
                      <button type="button" className="ml-2 text-robin hover:text-blue-700" onClick={() => handleEditClick('role')}>
                        <FaEdit />
                      </button>
                    </span>
                  )}
                </div>
              </div>
            </div>
            <div className="flex flex-col sm:flex-row gap-3 justify-evenly items-center w-full mt-2 sm:mt-4">
              <BackButton url={"/workers"} />
              <button
                type="button"
                className="w-full sm:w-auto bg-white text-red-600 border-2 border-red-600 px-4 py-2 rounded-lg hover:bg-red-500 hover:text-white transition-colors duration-200 font-semibold"
                onClick={handleRemoveWorker}
              >
                Delete Worker
              </button>
              <button
                type="submit"
                className="w-full sm:w-auto py-2 px-4 bg-robin rounded-lg text-white font-semibold hover:bg-blue-600 transition-colors duration-200"
              >
                Update Worker Info
              </button>
            </div>
          </form>
        </div>
      </div>

      {/* Modal for delete confirmation */}
      {showModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
          <div className="bg-white rounded-xl shadow-lg p-6 w-11/12 max-w-sm flex flex-col items-center">
            <h2 className="text-lg font-bold text-red-600 mb-2">Confirm Delete</h2>
            <p className="mb-4 text-center">Are you sure you want to delete <span className="font-semibold">{formData.newName} {formData.newLastName}</span>?</p>
            <div className="flex gap-4 w-full justify-center">
              <button
                onClick={handleCancelDelete}
                className="px-4 py-2 rounded-lg bg-gray-200 text-gray-700 font-semibold hover:bg-gray-300 transition-colors duration-150"
              >
                Cancel
              </button>
              <button
                onClick={handleConfirmDelete}
                className="px-4 py-2 rounded-lg bg-red-600 text-white font-semibold hover:bg-red-700 transition-colors duration-150"
              >
                Yes, Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default UpdateWorkerInfo


